module.exports = __webpack_public_path__ + "media/beep.0063e353.mp3";